<template>
	<div class="like-container text-center">
		<div class="d-flex align-items-center justify-content-center">
			<div class="icon-h" @click="incrementLike"><img :src="hIcon" alt="Like"></div>
			<span class="va-m fs-0-9">{{likeCount}}</span>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { urlBase, themeDir } from '../../variables.js'

export default {
	name: 'LikeHeartComponent',
	props: ['wrkId', 'ajaxObj', 'yearStr'],

	data() {
		return {
			likeCount: 0,
			hIcon: urlBase + themeDir + 'img/gallery-icone-cuore.svg',
			hIconOver: urlBase + themeDir + 'img/gallery-icone-cuore-cliccato.svg',
			likeDisabled: false
		}
	},

	methods: {
		getLikeNumber() {
			let url = this.ajaxObj.ajax_url

			var data = new FormData();
			data.append('action', 'nl_get_like_no')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('id_wrk', this.wrkId)
			data.append('yearStr', this.yearStr)

			axios.post(url, data)
				.then((response) => {
					this.likeCount = response.data.like
				}, (error) => {
					console.log(error);
				});
		},

		incrementLike() {
			if(!this.likeDisabled) {
				let url = this.ajaxObj.ajax_url

				var data = new FormData();
				data.append('action', 'nl_increment_like_no')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('id_wrk', this.wrkId)
				data.append('yearStr', this.yearStr)

				axios.post(url, data)
					.then((response) => {
						this.getLikeNumber()
						this.hIcon = this.hIconOver
						this.likeDisabled = true
					}, (error) => {
						console.log(error);
					});
			}
		}
	},

	mounted() {
		this.getLikeNumber()
	}
}
</script>

<style scoped>
.icon-h {
	width: 40px;
	height: auto;
	margin-right: 8px;
	margin-left: 20px;
	cursor: pointer;
}
</style>
